import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import React, { useEffect, useState } from "react";
import GlobalMeta from "../../reusable/GlobalMeta";
import InternalBanner from "../../reusable/fieldGroups/InternalBanner";
import PageMenu from "../../menus/PageMenu";
import Accreditations from "../../reusable/fieldGroups/Accreditations";
import LatestInsights from "../../reusable/LatestInsights";
import QuoteBanner from "../../layout/QuoteBanner";
import GridMenu from "../../menus/GridMenu";
import CallToAction from "../../layout/CallToAction";
import PageContent from "../../layout/PageContent";
import RandomTestimonial from "../../reusable/RandomTestimonial";

export default function Services() {

    const [pageData, setPageData] = useState();

    //Fetch page
    const { isPending, isError, data, error } = useQuery(
        ['services'], //Query key
        () => axios({ //Query function
            method: 'get',
            url: WP_API_Settings.endpoint + 'wp/v2/pages?slug=services&_embed=true&acf_format=standard'
        })
    );

    useEffect(() => {
        if (data?.data) {
            setPageData(data.data[0]);
        }
    }, [data]);

    //console.log(pageData)

    return (
        <>
            <GlobalMeta />
            <InternalBanner
                featuredImage={pageData?._embedded?.['wp:featuredmedia']?.[0]?.source_url}
                banner={pageData?.acf.internal_banner}
            />
            <PageMenu
                items={pageData?.acf.page_menu}
                loading={!pageData}
                services={true}
            />
            <PageContent
                content={pageData?.content.rendered}
            />
            <GridMenu
                items={pageData?.acf.page_menu}
                loading={!pageData}
            />
            <Accreditations
                accreditations={pageData?.acf.accreditations}
                loading={!pageData}
                page={'services'}
            />
            <CallToAction
                data={pageData?.acf.call_to_action}
            />
            <RandomTestimonial
                testimonials={pageData?.acf.testimonials}
                loading={!pageData}
            />
            <LatestInsights
                loading={!pageData}
            />
        </>
    );
}